export default __webpack_public_path__ + "f1568a7e634449419297185af6a0b205.png";